import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-7909">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-7910">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-7911">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-7912">
            <ArrowLeft className="w-4 h-4" data-id="element-7913" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-7914">NOIZA</div>
          <div className="w-20" data-id="element-7915" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-7916">
        <div className="mb-12" data-id="element-7917">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-7918">
            <FileText className="w-6 h-6 text-white/80" data-id="element-7919" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-7920">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-7921">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-7922">
          <section data-id="element-7923">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7924">
              <span className="text-[#006847]" data-id="element-7925">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7926">
              <p data-id="element-7927">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-7928">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7929">
                <li data-id="element-7930">Haber leído íntegramente este documento</li>
                <li data-id="element-7931">Comprender su contenido en su totalidad</li>
                <li data-id="element-7932">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-7933">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-7934">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7935">
              <span className="text-[#006847]" data-id="element-7936">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-7937">
              <p data-id="element-7938">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7939">
                <li data-id="element-7940">Software como servicio (SaaS)</li>
                <li data-id="element-7941">Marketplace digital gastronómico</li>
                <li data-id="element-7942">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-7943">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7944">
                <li data-id="element-7945">Mostrar su menú digital</li>
                <li data-id="element-7946">Recibir pedidos de clientes</li>
                <li data-id="element-7947">Gestionar su operación interna</li>
                <li data-id="element-7948">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-7949">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-7950">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7951">
              <span className="text-[#006847]" data-id="element-7952">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7953">
              <p data-id="element-7954">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7955">
                <li data-id="element-7956">No es proveedor de alimentos</li>
                <li data-id="element-7957">No participa en la preparación de productos</li>
                <li data-id="element-7958">No manipula alimentos en ningún momento</li>
                <li data-id="element-7959">No realiza entregas ni logística</li>
                <li data-id="element-7960">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-7961">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-7962">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-7963">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7964">
              <span className="text-[#006847]" data-id="element-7965">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-7966">
              <p data-id="element-7967">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-7968">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7969">
                <li data-id="element-7970">El restaurante es el único responsable de su operación</li>
                <li data-id="element-7971">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-7972">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-7973">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7974">
                <li data-id="element-7975">Precios</li>
                <li data-id="element-7976">Menú</li>
                <li data-id="element-7977">Horarios</li>
                <li data-id="element-7978">Métodos de pago</li>
                <li data-id="element-7979">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7980">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7981">
              <span className="text-[#006847]" data-id="element-7982">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-7983">
              <div data-id="element-7984">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7985">
                  5.1. Alcance general
                </h3>
                <p data-id="element-7986">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-7987">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7988">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-7989">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-7990">
                  <li data-id="element-7991">Calidad de los alimentos</li>
                  <li data-id="element-7992">Estado, frescura o preparación</li>
                  <li data-id="element-7993">Ingredientes utilizados</li>
                  <li data-id="element-7994">Contaminación cruzada</li>
                  <li data-id="element-7995">Problemas de higiene o salubridad</li>
                  <li data-id="element-7996">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-7997">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-7998">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7999">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8000">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8001">
                  <li data-id="element-8002">Retrasos en la entrega</li>
                  <li data-id="element-8003">Pérdida de pedidos</li>
                  <li data-id="element-8004">Entregas incompletas</li>
                  <li data-id="element-8005">Errores en dirección</li>
                  <li data-id="element-8006">Conducta de repartidores</li>
                  <li data-id="element-8007">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8008">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8009">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8010">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8011">
                  <li data-id="element-8012">Recepción de pagos</li>
                  <li data-id="element-8013">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8014">Manejo de efectivo</li>
                  <li data-id="element-8015">Confirmación de pagos</li>
                  <li data-id="element-8016">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8017">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8018">
                  <li data-id="element-8019">Pagos no recibidos</li>
                  <li data-id="element-8020">Comprobantes falsos</li>
                  <li data-id="element-8021">Errores en montos</li>
                  <li data-id="element-8022">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8023">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8024">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8025">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8026">
                  <li data-id="element-8027">Reclamos de clientes</li>
                  <li data-id="element-8028">Reembolsos</li>
                  <li data-id="element-8029">Cancelaciones</li>
                  <li data-id="element-8030">Disputas</li>
                  <li data-id="element-8031">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8032">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8033">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8034">
              <span className="text-[#006847]" data-id="element-8035">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8036">
              <p data-id="element-8037">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8038">
                <li data-id="element-8039">Responsable</li>
                <li data-id="element-8040">Legal</li>
                <li data-id="element-8041">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8042">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8043">
                <li data-id="element-8044">Publicar información falsa</li>
                <li data-id="element-8045">Manipular precios de forma engañosa</li>
                <li data-id="element-8046">Simular disponibilidad inexistente</li>
                <li data-id="element-8047">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8048">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8049">
              <span className="text-[#006847]" data-id="element-8050">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8051">
              <p data-id="element-8052">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8053">
                <li data-id="element-8054">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8055">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8056">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8057">
                <li data-id="element-8058">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8059">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8060">
                    <li data-id="element-8061">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8062">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8063">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8064">
              <span className="text-[#006847]" data-id="element-8065">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8066">
              <p data-id="element-8067">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8068">
                <li data-id="element-8069">Menú digital</li>
                <li data-id="element-8070">Gestión de pedidos</li>
                <li data-id="element-8071">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8072">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8073">
                  <p className="font-medium text-white mb-2" data-id="element-8074">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8075">
                    <li data-id="element-8076">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8077">
                  <p className="font-medium text-white mb-2" data-id="element-8078">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8079">
                    <li data-id="element-8080">Propiedad del software</li>
                    <li data-id="element-8081">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8082">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8083">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8084">
              <span className="text-[#006847]" data-id="element-8085">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8086">
              <p data-id="element-8087">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8088">
                <li data-id="element-8089">Disponibilidad continua</li>
                <li data-id="element-8090">Funcionamiento sin interrupciones</li>
                <li data-id="element-8091">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8092">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8093">
                <li data-id="element-8094">Fallas técnicas</li>
                <li data-id="element-8095">Actualizaciones</li>
                <li data-id="element-8096">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8097">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8098">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8099">
              <span className="text-[#006847]" data-id="element-8100">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8101">
              <p data-id="element-8102">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8103">
                <li data-id="element-8104">No está garantizada permanentemente</li>
                <li data-id="element-8105">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8106">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8107">
                <li data-id="element-8108">Destacar o no restaurantes</li>
                <li data-id="element-8109">Modificar posiciones</li>
                <li data-id="element-8110">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8111">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8112">
              <span className="text-[#006847]" data-id="element-8113">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8114">
              <p data-id="element-8115">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8116">
                <li data-id="element-8117">Cumplir con los pagos acordados</li>
                <li data-id="element-8118">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8119">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8120">
                <li data-id="element-8121">Suspender el servicio</li>
                <li data-id="element-8122">Limitar funcionalidades</li>
                <li data-id="element-8123">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8124">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8125">
              <span className="text-[#006847]" data-id="element-8126">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8127">
              <p data-id="element-8128">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8129">
                <li data-id="element-8130">Incumplimiento de términos</li>
                <li data-id="element-8131">Uso indebido</li>
                <li data-id="element-8132">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8133">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8134">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8135">
              <span className="text-[#006847]" data-id="element-8136">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8137">
              <p data-id="element-8138">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8139">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8140">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8141">
              <span className="text-[#006847]" data-id="element-8142">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8143">
              <p data-id="element-8144">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8145">
                <li data-id="element-8146">Pérdidas económicas</li>
                <li data-id="element-8147">Daños indirectos</li>
                <li data-id="element-8148">Lucro cesante</li>
                <li data-id="element-8149">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8150">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8151">
              <span className="text-[#006847]" data-id="element-8152">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8153">
              <p data-id="element-8154">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8155">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8156">
              <span className="text-[#006847]" data-id="element-8157">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8158">
              <p className="font-medium" data-id="element-8159">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8160">
                <li data-id="element-8161">Ha leído este documento completo</li>
                <li data-id="element-8162">Comprende su alcance</li>
                <li data-id="element-8163">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}